// extracted by mini-css-extract-plugin
module.exports = {"comp":"PowerBackup2_comp__T8oLD"};